import { Modal, Button } from '@iba-team/portal-react-components/dist';
import { useTranslation } from 'react-i18next';
import defaultSettingsImage from '../../../assets/absence-settings.png';
import './RestoreDefaultSettingsModal.scss';

export type RestoreDefaultSettingsModalI = {
  isVisible: boolean,
  onClose: () => void,
  onRestore: () => void,
}

export const RestoreDefaultSettingsModal = ({ onRestore, onClose, isVisible }: RestoreDefaultSettingsModalI) => {
  const { t } = useTranslation();

  return (
    <Modal visible={isVisible}
      titleText={t('absenceSettingsModal.defaultModal.title')}
      footer={[
        <Button theme={{ variant: 'neutral', color: 'grey' }}
          onClick={() => {
            onClose();
          }}>
          {t('cancel')}
        </Button>,
        <Button theme={{ variant: 'primary', color: 'green' }}
          onClick={() => {
            onRestore();
            onClose();
          }}>
          {t('absenceSettingsModal.defaultModal.restoreBtn')}
        </Button>
      ]}
      onClose={() => {
        onClose();
      }}
    >
      <div className={'defaultSettings__block1'}>{t('absenceSettingsModal.defaultModal.text1')}</div>
      <div className={'defaultSettings__block2'}>{t('absenceSettingsModal.defaultModal.text2')}</div>
      <img className={'defaultSettings__img'} src={defaultSettingsImage} alt={'default settings'}></img>
    </Modal>
  );
};